import React, { FC } from 'react';
import { IonIcon } from '@ionic/react';
import * as Icons from 'ionicons/icons';
import { AllieList, AllieItem, AllieText } from '../../../../components';
import {
  LanguageContainer,
  LanguageOption,
  StyledContainer,
  StyledItem,
  UserMenuItem,
} from './Header.styles';

export interface ListOptionsMenuProps {
  loggedUser?: {
    name: string;
    avatar?: string;
  };
  options: {
    label: string;
    onClick: () => void;
    icon: keyof typeof Icons;
  }[];
  currentLanguage: string;
  languages: { code: string; name: string }[];
  onLanguageChange: (language: string) => void;
  languageLabel: string;
}

export const ListOptionsMenu: FC<ListOptionsMenuProps> = ({
  options,
  currentLanguage,
  onLanguageChange,
  languages,
  languageLabel,
}) => {
  return (
    <AllieList>
      {options.map(({ label, onClick, icon }, index) => (
        <>
          {index === options.length - 1 && (
            <LanguageContainer>
              <AllieText type="body2" color="neutral-70">
                {languageLabel}
              </AllieText>
              {languages.map((lang) => (
                <StyledItem>
                  <LanguageOption
                    key={lang.code}
                    checked={currentLanguage === lang.code}
                    onclick={() => onLanguageChange(lang.code)}
                    size={15}
                  />
                  <AllieText style={{ margin: 10 }}>{lang.name}</AllieText>
                </StyledItem>
              ))}
            </LanguageContainer>
          )}
          <UserMenuItem
            key={`${index}-label`}
            onclick={onClick}
            button
            lines="none"
            isLast={index === options.length - 1}
            data-testid={index === options.length - 1 ? 'logout-button' : undefined}
          >
            <StyledContainer>
              <IonIcon icon={Icons[icon]} style={{ fontSize: '20px' }} />
              <AllieText color="primary-90" style={{ whiteSpace: 'nowrap' }}>
                {label}
              </AllieText>
            </StyledContainer>
          </UserMenuItem>
        </>
      ))}
    </AllieList>
  );
};
